import React, { Component } from "react";
import "./css/ResultScreenMobile.css";

import BattenButton from "./src/Button_Batten.png";
import FloorButton from "./src/Button_Floor.png";
import SheraImage from "./src/iCon-full.png";
import ShopImage from "./src/iCon-shop.png";
import ShowResult from "./src/show_result.png";

import Axios from "axios";

export default class ResultScreenMobile extends Component {
  constructor() {
    super();
    this.state = { dataFloor: [], dataBatten: [] };
  }

  onClickShare = () => {
    // console.log("onClickShare");

    const url =
      "https://www.shera.com/AR/share/" +
      this.props.currentBatten.id +
      "/" +
      this.props.currentFloor.id;

    if (navigator.share) {
      navigator
        .share({
          url: url,
        })
        .then(() => {
          console.log("Sharing successfull");
        })
        .catch(() => {
          console.log("Sharing failed");
        });
    } else {
      alert("Browser does not support share");
    }
  };

  async componentDidMount() {
    ///////////////////////Floor part///////////////////////////
    const floor_url =
      "https://www.shera.com/AR/api/search.php?sqli=id,track,name,class,striped,color,size,width,numpersqm,imagelink,iconlink&table=floors&where=track&value=1";

    const resultFloor = await Axios.get(floor_url);
    this.setState({ dataFloor: resultFloor.data });

    ///////////////////////Batten part///////////////////////////
    const batten_url =
      "https://www.shera.com/AR/api/search.php?sqli=id,track,name,class,striped,color,size,width,numpersqm,imagelink,iconlink&table=battens&where=track&value=1";

    const resultBatten = await Axios.get(batten_url);
    this.setState({ dataBatten: resultBatten.data });
  }

  async componentDidUpdate(prev) {
    ///////////////////////Floor part///////////////////////////
    if (prev.currentFloor.track !== this.props.currentFloor.track) {
      const floor_url =
        "https://www.shera.com/AR/api/search.php?sqli=id,track,name,class,striped,color,size,width,numpersqm,imagelink,iconlink&table=floors&where=track&value=" +
        this.props.currentFloor.track;

      const resultFloor = await Axios.get(floor_url);
      this.setState({ dataFloor: resultFloor.data });
    }

    ///////////////////////Batten part///////////////////////////
    if (prev.currentFloor.track !== this.props.currentFloor.track) {
      const batten_url =
        "https://www.shera.com/AR/api/search.php?sqli=id,track,name,class,striped,color,size,width,numpersqm,imagelink,iconlink&table=battens&where=track&value=" +
        this.props.currentBatten.track;

      const resultBatten = await Axios.get(batten_url);
      this.setState({ dataBatten: resultBatten.data });
    }
  }

  render() {
    return (
      <>
        <div className="resultScreen-mobile-image-container">
          <div className="resultScreen-mobile-image-top-container">
            <img
              className="resultScreen-mobile-image-top"
              src={this.props.currentBatten.imagelink}
              alt="Batten"
            />
          </div>
          <img
            className="resultScreen-mobile-image-bottom"
            src={this.props.currentFloor.imagelink}
            alt="Floor"
          />
          <div
            className="resultScreen-mobile-resultIcon"
            onClick={this.props.onClose}
          >
            <img
              className="resultScreen-mobile-resultIcon-image"
              src={ShowResult}
              alt=""
            />
            <p className="resultScreen-mobile-resultIcon-text">ปิดผลลัพท์</p>
          </div>
        </div>

        <div className="resultScreen-mobile-info-container">
          <div className="resultScreen-mobile-info">
            <div className="resultScreen-mobile-info-header">
              <div>
                <img
                  className="resultScreen-mobile-info-icon"
                  src={BattenButton}
                  alt=""
                />
              </div>

              <div className="resultScreen-mobile-info-button-container">
                {/* <div
                  className="resultScreen-mobile-btn-left"
                  onClick={() => this.props.onEcommerce("batten")}
                >
                  <img
                    className="resultScreen-mobile-menu-image"
                    src={ShopImage}
                    alt=""
                  />
                  <div className="resultScreen-mobile-menu-text">ซื้อเลย</div>
                </div> */}
                <div
                  className="resultScreen-mobile-btn-right"
                  onClick={this.onClickShare}
                >
                  <img
                    className="resultScreen-mobile-menu-image"
                    src={SheraImage}
                    alt=""
                  />
                  <div className="resultScreen-mobile-menu-text">แชร์</div>
                </div>
              </div>
            </div>

            <div className="resultScreen-mobile-info-body">
              <div className="container">
                <div className="row">
                  <div className="col-sm-auto">
                    <img
                      className="resultScreen-mobile-info-body-icon"
                      src={this.props.currentBatten.iconlink}
                      alt=""
                    />
                  </div>
                  <div className="col">
                    <div className="row header-text">
                      {this.props.currentBatten.name}
                    </div>
                    <div className="row">
                      <table className="table table-borderless">
                        <thead style={{ backgroundColor: "#E6E7E8" }}>
                          <tr>
                            <th scope="col">รุ่น</th>
                            <th scope="col">ลาย</th>
                            <th scope="col">สี</th>
                            <th scope="col">
                              <div>ขนาด (ซม.)</div>
                              <div>(หนา * กว้าง * ยาว)</div>
                            </th>
                            <th scope="col">
                              <div>จำนวน</div>
                              <div>(แผ่น/ตร.ม.)</div>
                            </th>
                          </tr>
                        </thead>
                        <tbody style={{ backgroundColor: "white" }}>
                          {this.state.dataBatten.map((data) => (
                            <tr key={data.id}>
                              <th scope="col">{data.class}</th>
                              <th scope="col">{data.striped}</th>
                              <th scope="col">{data.color}</th>
                              <th scope="col">{data.size}</th>
                              <th scope="col">{data.numpersqm}</th>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="resultScreen-mobile-info">
            <div className="resultScreen-mobile-info-header">
              <img
                className="resultScreen-mobile-info-icon"
                src={FloorButton}
                alt=""
              />
              <div className="resultScreen-mobile-info-button-container">
                {/* <div
                  className="resultScreen-mobile-btn-left"
                  onClick={() => this.props.onEcommerce("floor")}
                >
                  <img
                    className="resultScreen-mobile-menu-image"
                    src={ShopImage}
                    alt=""
                  />
                  <div className="resultScreen-mobile-menu-text">ซื้อเลย</div>
                </div> */}
                <div
                  className="resultScreen-mobile-btn-right"
                  onClick={this.onClickShare}
                >
                  <img
                    className="resultScreen-mobile-menu-image"
                    src={SheraImage}
                    alt=""
                  />
                  <div className="resultScreen-mobile-menu-text">แชร์</div>
                </div>
                {/* <div
                  className="resultScreen-mobile-info-button"
                  onClick={() => this.props.onEcommerce("floor")}
                >
                  <img
                    className="resultScreen-mobile-info-button-image"
                    src={ShopImage}
                    alt=""
                  />
                  <div className="resultScreen-mobile-info-button-text">
                    ซื้อเลย
                  </div>
                </div>
                <div className="resultScreen-mobile-info-button-bar" />
                <div
                  className="resultScreen-mobile-info-button"
                  onClick={this.onClickShare}
                >
                  <img
                    className="resultScreen-mobile-info-button-image"
                    src={SheraImage}
                    alt=""
                  />
                  <div className="resultScreen-mobile-info-button-text">
                    แบ่งปัน
                  </div>
                </div> */}
              </div>
            </div>
            <div className="resultScreen-mobile-info-body">
              <div className="container">
                <div className="row">
                  <div className="col-sm-auto">
                    <img
                      className="resultScreen-mobile-info-body-icon"
                      src={this.props.currentFloor.iconlink}
                      alt=""
                    />
                  </div>
                  <div className="col">
                    <div className="row header-text">
                      {this.props.currentFloor.name}
                    </div>
                    <div className="row">
                      <table className="table table-borderless">
                        <thead style={{ backgroundColor: "#E6E7E8" }}>
                          <tr>
                            <th scope="col">รุ่น</th>
                            <th scope="col">ลาย</th>
                            <th scope="col">สี</th>
                            <th scope="col">
                              <div>ขนาด (ซม.)</div>
                              <div>(หนา * กว้าง * ยาว)</div>
                            </th>
                            <th scope="col">
                              <div>จำนวน</div>
                              <div>(แผ่น/ตร.ม.)</div>
                            </th>
                          </tr>
                        </thead>
                        <tbody style={{ backgroundColor: "white" }}>
                          {this.state.dataFloor.map((data) => (
                            <tr key={data.id}>
                              <th scope="col">{data.class}</th>
                              <th scope="col">{data.striped}</th>
                              <th scope="col">{data.color}</th>
                              <th scope="col">{data.size}</th>
                              <th scope="col">{data.numpersqm}</th>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
